import React from "react"
import ContentTransformer from "../../../src/components/Transformers/content-transformer"
import {
  formulairepaiementContainer,
  formulairepaiement,
  formulairepaiementTitle,
  formulairePaiementDescRef,
} from "./formulaire-paiement.module.scss"
import PropTypes from "prop-types"
import { useBuildData } from "../../../src/hooks/use-build-data"
import FadeIn from "react-fade-in"
import { Title } from "./formulaire-paiement-styled"

const maxRefdetLength = 30
const wantedExerLength = 4

//-----------------------Parent component---------------------------//

const FormulairePaiement = ({ formulairePaiement, location }) => {
  const buildColors = useBuildData().theme_settings.palette
  return (
    <section className={formulairepaiementContainer}>
      <FadeIn delay={150}>
        <FormulairePaiementHeader
          colors={buildColors}
          formulairePaiement={formulairePaiement}
        />
        <p>Tous les champs sont obligatoires</p>
        <FormulairePaiementForm
          location={location}
          formulairePaiement={formulairePaiement}
        />
      </FadeIn>
    </section>
  )
}

//-----------------------Parent component---------------------------//

function isNumeric(str) {
  return /^\d+$/.test(str)
}
function countDecimals(value) {
  if (Math.floor(value) === value) return 0
  const str = value.toString()
  if (str.indexOf(".") !== -1 && str.indexOf("-") !== -1) {
    return str.split("-")[1] || 0
  } else if (str.indexOf(".") !== -1) {
    return str.split(".")[1].length || 0
  }
  return str.split("-")[1] || 0
}

const submitPayfip = (location) => (event) => {
  event.preventDefault()
  let paddedRefDet
  let refdetUrlValue
  const mail = document.getElementById("MEL").value
  const mailValid = mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
  if (!mail || !mailValid) {
    alert("Veuillez entrer une adresse mail valide.")
    return
  }
  const refdet = document.getElementById("REFDET").value
  const typeForm = document.getElementById("TYPEFORM").value
  const modeSaisie = document.getElementById("MODESAISIE").value
  const rolrec = document.getElementById("ROLREC")?.value
  const roldeb = document.getElementById("ROLDEB")?.value
  const idLigne = document.getElementById("IDLIGNE")?.value
  const numOrdre = document.getElementById("NUMORDRE")?.value
  if (refdet) {
    if (isNumeric(refdet)) {
      if (typeForm === "INDIGO" || typeForm === "PESV2") {
        if (refdet.length <= 8) {
          paddedRefDet = refdet.padStart(8, "0")
        } else {
          alert(
            "Veuillez entrer une référence de facture valide. 8 chiffres maximum"
          )
          return
        }
      } else if (typeForm === "ROLMRE") {
        if (refdet.length <= 13) {
          paddedRefDet = refdet.padStart(13, "0")
        } else {
          alert(
            "Veuillez entrer une référence de facture valide. 13 chiffres maximum"
          )
          return
        }
      }
    } else {
      alert(
        "Veuillez entrer une référence de facture valide. La référence doit être un nombre"
      )
      return
    }
  } else {
    alert("Veuillez entrer une référence de facture.")
    return
  }
  const exer = document.getElementById("EXER").value
  if (
    !exer ||
    exer.length !== wantedExerLength ||
    (modeSaisie !== "T" && Number(exer) > new Date().getFullYear())
  ) {
    alert("Veuillez entrer une année valide.")
    return
  }
  let montant = document.getElementById("MONTANT").value //eslint-disable-next-line eqeqeq
  if (!montant || countDecimals(montant) > 2 || montant == 0) {
    alert(
      "Veuillez entrer un montant valide. Le montant doit être en euros et avec deux décimales maximum."
    )
    return
  }
  const centMultiplier = 100
  montant = Math.round(parseFloat(montant) * centMultiplier)

  const numcli = document.getElementById("NUMCLI").value.padStart(6, "0")
  const urlPayfip = process.env.GATSBY_TIPI_URL + "/tpa/paiement.web?"
  if (typeForm === "ROLMRE") {
    refdetUrlValue = exer + rolrec + roldeb + paddedRefDet
  } else if (typeForm === "PESV2") {
    refdetUrlValue = exer + paddedRefDet + idLigne
  } else if (typeForm === "INDIGO") {
    refdetUrlValue = exer + paddedRefDet + numOrdre
  }
  const finalUrlPayfip = `${urlPayfip}exer=${exer}&refdet=${refdetUrlValue}&montant=${montant}&mel=${mail}&saisie=${modeSaisie}&numcli=${numcli}&urlcl=${
    location.href + "-retour"
  }`
  const data = {
    host: window.location.origin,
    email: mail,
    montant: montant,
    ref: paddedRefDet,
    numcli: numcli,
    exer: exer,
  }
  const baseUrl = process.env.GATSBY_ESPACE_CITOYEN_URL
  const url = baseUrl + "/payfip_submit_form"
  const options = {
    method: "POST",
    cache: "no-cache",
    credentials: "omit",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }
  fetch(url, options).then((response) => {
    response.text().then(() => {
      window.location.href = finalUrlPayfip
      return null
    })
    return response
  })
}

//-----------------------Child component/Header---------------------------//

const FormulairePaiementHeader = ({ formulairePaiement, colors }) => (
  <article className={formulairepaiement}>
    <Title
      textColor={colors.a_color_gradients.a_dark}
      className={formulairepaiementTitle}
    >
      {formulairePaiement.title}
    </Title>
    {formulairePaiement.body && (
      <ContentTransformer content={formulairePaiement.body.processed} />
    )}
  </article>
)
//-----------------------Child component/Header---------------------------//

const FormulairePaiementForm = ({ formulairePaiement, location }) => (
  <>
    <input
      type="text"
      id="MEL"
      title="Mail"
      autoComplete={"email"}
      placeholder="Mail"
      aria-label="Mail"
    />
    <input
      type="text"
      maxLength={maxRefdetLength}
      id="REFDET"
      title={`Référence dette ${
        formulairePaiement.field_description_de_la_referenc ? "*" : ""
      }`}
      placeholder={`Référence dette ${
        formulairePaiement.field_description_de_la_referenc ? "*" : ""
      }`}
      aria-label={`Référence dette ${
        formulairePaiement.field_description_de_la_referenc ? "*" : ""
      }`}
    />

    {formulairePaiement.field_description_de_la_referenc && (
      <div className={formulairePaiementDescRef}>
        <ContentTransformer
          content={
            formulairePaiement.field_description_de_la_referenc.processed
          }
        />
      </div>
    )}
    <input
      type="number"
      maxLength={wantedExerLength}
      id="EXER"
      title="Année"
      placeholder="Année"
      aria-label="Année"
    />
    <input
      type="number"
      step="0.01"
      min="0.01"
      max="99999.99"
      id="MONTANT"
      title="Montant en euros"
      placeholder="Montant en euros"
      aria-label="Montant en euros"
    />
    <input
      type="hidden"
      id="NUMCLI"
      value={formulairePaiement.field_code_exercice}
      readOnly
    />
    {formulairePaiement.field_type_de_formulaire === "ROLMRE" ? (
      <>
        <input
          type="hidden"
          id="ROLREC"
          value={formulairePaiement.field_rolrec}
          readOnly
        />
        <input
          type="hidden"
          id="ROLDEB"
          value={formulairePaiement.field_roldeb}
          readOnly
        />
      </>
    ) : formulairePaiement.field_type_de_formulaire === "PESV2" ? (
      <input
        type="hidden"
        id="IDLIGNE"
        value={formulairePaiement.field_id_ligne}
        readOnly
      />
    ) : formulairePaiement.field_type_de_formulaire === "INDIGO" ? (
      <input
        type="hidden"
        id="NUMORDRE"
        value={formulairePaiement.field_num_ordre}
        readOnly
      />
    ) : null}
    <input
      type="hidden"
      id="MODESAISIE"
      value={formulairePaiement.field_mode_de_saisie}
      readOnly
    />
    <input
      type="hidden"
      id="TYPEFORM"
      value={formulairePaiement.field_type_de_formulaire}
      readOnly
    />
    <input
      type="submit"
      value="Valider"
      aria-label="Valider"
      onClick={submitPayfip(location)}
    />
  </>
)

//-----------------------Prop-Types---------------------------//

FormulairePaiement.propTypes = {
  formulairePaiement: PropTypes.object.isRequired,
  location: PropTypes.object,
}
FormulairePaiementHeader.propTypes = {
  formulairePaiement: PropTypes.object.isRequired,
  colors: PropTypes.object,
}
FormulairePaiementForm.propTypes = {
  formulairePaiement: PropTypes.object.isRequired,
  location: PropTypes.object,
}
//-----------------------Prop-Types---------------------------//

export default FormulairePaiement
